// src/components/Admin.jsx
import React from 'react';
import { useAuth } from '../hooks/useAuth';
import AdminLogin from './AdminLogin';
import AdminPanel from './AdminPanel';

const Admin = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#D67441]"></div>
      </div>
    );
  }

  return user ? <AdminPanel /> : <AdminLogin />;
};

export default Admin;
